import { render, staticRenderFns } from "./TipoLugarInteresModalEdicion.vue?vue&type=template&id=70572031&scoped=true&"
import script from "./TipoLugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoLugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoLugarInteresModalEdicion.vue?vue&type=style&index=0&id=70572031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70572031",
  null
  
)

export default component.exports